import apiClient from './client';

export interface CoursePurchaseStatus {
  hasAccess: boolean;
  requiresPurchase: boolean;
  isPurchased: boolean;
  isFree: boolean;
  isSharedFromSuperAdmin: boolean;
  isBranchCourse: boolean;
  purchaseStatus: 'available' | 'purchased' | 'locked';
}

export interface CoursePurchaseOrder {
  orderId: string;
  amount: number;
  currency: string;
  receipt: string;
  paymentId: string;
}

export const coursesApi = {
  // Get course access status
  getCourseAccessStatus: async (courseId: string): Promise<CoursePurchaseStatus> => {
    const response = await apiClient.get<{
      success: boolean;
      data: CoursePurchaseStatus;
    }>(`/courses/${courseId}/access-status`);
    return response.data;
  },

  // Create course purchase order
  createCoursePurchaseOrder: async (courseId: string): Promise<CoursePurchaseOrder> => {
    const response = await apiClient.post<any>(`/courses/${courseId}/purchase`);
    
    // Handle nested response structure
    // Response structure: { success, data: { success, data: { orderId, amount, ... } } }
    let orderData: CoursePurchaseOrder;
    
    if (response.data?.data?.data) {
      // Double nested structure
      orderData = response.data.data.data;
    } else if (response.data?.data) {
      // Single nested structure
      orderData = response.data.data;
    } else if (response.data) {
      // Direct structure
      orderData = response.data;
    } else {
      throw new Error('Invalid response structure from purchase endpoint');
    }
    
    // Validate required fields
    if (!orderData.orderId || !orderData.amount) {
      console.error('Invalid order data:', orderData);
      throw new Error('Order data missing required fields');
    }
    
    return orderData;
  },

  // Verify course purchase payment
  verifyCoursePurchase: async (
    courseId: string,
    paymentData: {
      razorpay_order_id: string;
      razorpay_payment_id: string;
      razorpay_signature: string;
    }
  ): Promise<{ success: boolean; data: any }> => {
    const response = await apiClient.post<{
      success: boolean;
      data: any;
    }>(`/payments/course-purchase/verify`, {
      ...paymentData,
      courseId,
    });
    return response;
  },

  // Public endpoint to get courses for homepage
  getHomepageCourses: async (): Promise<{
    success: boolean;
    statusCode: number;
    message: string;
    data: {
      data: any[];
    };
    timestamp: string;
  }> => {
    const response = await apiClient.get<{
      success: boolean;
      statusCode: number;
      message: string;
      data: {
        data: any[];
      };
      timestamp: string;
    }>('/public/courses/homepage');
    return response as {
      success: boolean;
      statusCode: number;
      message: string;
      data: {
        data: any[];
      };
      timestamp: string;
    };
  },
};


